import { distributionOption } from "../components/server/createInstance/createInstance.Constant";
export const isPositiveNonZero = (val) => {
  return /^\+?[1-9]\d*$/.test(val);
};

export const isNumber = (val) => {
  return /^\+?[0-9]\d*$/.test(val);
};

export const randomGen = () => {
  return (Math.floor(Math.random() * 10000) + 1);
};

export const getUnique = (array, key) => {
  if(typeof key !== 'function') {
    const property = key;
    key = function (item) { return item[property]; };
  }
  return Array.from(array.reduce(function (map, item) {
    const k = key(item);
    if(!map.has(k)) map.set(k, item);
    return map;
  }, new Map()).values());
};

export const formatBytes = (bytes, decimals = 2) => {
  if(bytes === 0) return '0 Bytes';

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return Math.ceil((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const formatBandwidthBytes = (bytes, isYearly, decimals = 2) => {
  if(bytes === 0) return '0 Bytes';

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  let bandwidthVal = Math.round((bytes / Math.pow(k, i) * 10).toFixed(dm)) / 10;
  // if(isYearly) {
  //   bandwidthVal = bandwidthVal * 12;
  //}

  return bandwidthVal + ' ' + sizes[i];
};

export const convertgbtotb = (param) => {

  let num = param.slice(0, -2).trim();
  return Math.round((num / 1024) * 1000) / 1000;
};

export const formatBytesFloat = (bytes) => {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if(bytes == 0) return '0 Bytes';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  var tempPow = 1024;
  if(i == 4) {
    var gbs = (bytes / Math.pow(tempPow, i - 1));
    return (gbs / 1000).toFixed(2) + ' ' + sizes[i];
  } else
    return (bytes / Math.pow(tempPow, i)).toFixed(2) + ' ' + sizes[i];
};

export const getLocalTime = (date) => {
  let d = new Date(date);
  return d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const getLocalDay = (date) => {
  let d = new Date(date);
  return d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear();
};

export const dateInUTC = () => {
  let now = new Date();
  let startUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
  return startUtc.getTime();
};

export const getDistUserName = (type) => {
  let user = type;
  if(type === undefined || type === '') {
    return;
  }
  for(let i = 0; i < distributionOption.length; i++) {
    let item = distributionOption[i];
    if(type.includes(item.type)) {
      user = item.user;
      break;
    }
  }
  return user;
};

export const getPsswdStrength = (psswd) => {
  //const strongPwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
  //const mediumPwd = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

  var str = psswd;
  var patt1 = new RegExp("^(?=.*[a-z])(?=(.*[A-Z]))(?=.*[0-9])(?=.*[-_!@#\$%\^&\*])(?=.{6,})");
  var charRegEx = new RegExp("^[a-zA-z0-9]");
  var charRegEx1 = new RegExp("^[a-zA-z]");
  var str2 = str.slice(1, -1);
  var char1 = str.charAt(0);
  var char2 = str.charAt(str.length - 1);


  var result = charRegEx.test(char1) && patt1.test(str2) && charRegEx1.test(char2);

  if(result) {
    return "Strong";
  }
  return "Weak";
};

export const getFullRegionDetail = (fullRegionList, region) => {
  if(fullRegionList === null || fullRegionList === undefined) {
    return region;
  }
  let ob = fullRegionList.find(item => item.region_id === region);
  if(ob !== undefined) {
    return ob.name + ', ' + '(' + region + ')';
  } else {
    let getOb = JSON.parse(localStorage.getItem('allRegionList'));
    if(getOb === null || getOb === undefined) {
      return region;
    }
    let regLi = getOb.find(item => item.region_id === region);
    if(regLi != undefined) {
      return regLi.name + ', ' + '(' + region + ')';
    }
    else {
      return region;
    }

  }
};

export const getRandomPassword = () => {
  const upperchar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowerchar = 'abcdefghijklmnopqrstuvwxyz';
  const numberchar = '0123456789';
  const specialchar = '!@#$%^&*';

  var randomPasswd = '';
  randomPasswd = lowerchar.charAt(Math.floor(Math.random() * lowerchar.length));
  randomPasswd = randomPasswd + upperchar.charAt(Math.floor(Math.random() * upperchar.length));
  randomPasswd = randomPasswd + numberchar.charAt(Math.floor(Math.random() * numberchar.length));
  randomPasswd = randomPasswd + specialchar.charAt(Math.floor(Math.random() * specialchar.length));
  randomPasswd = randomPasswd + Math.random().toString(36).slice(-3);
  randomPasswd = randomPasswd + lowerchar.charAt(Math.floor(Math.random() * lowerchar.length));

  return randomPasswd;
};

export const removeSpecialCharacter = (name) => {
  let newName = name.replace(/[!@#$%^&*_.]/g, "-");
  newName = newName.replace(/[ ]/g, "");
  return newName;
};

export const maskEmail = (email) => {
  var maskedEmail = email.replace(/([^@\.])/g, "*").split('');
  var previous = "";
  for(var i = 0; i < maskedEmail.length; i++) {
    if(i <= 1 || previous == "." || previous == "@") {
      maskedEmail[i] = email[i];
    }
    previous = email[i];
  }
  return maskedEmail.join('');
};

export const getCookieValueByName = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while(c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if(c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const removeCookieValueByName = (cname) => {
  var d = new Date();
  d.setTime(d.getTime() - (24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + getCookieValueByName(cname) + ";" + expires;
};

export const isKeyValid = (rawKey) => {
  var checkIntegers, error, getBytesAndSplit, humanType, keyBase64, keyBody, keyBytes, keyTokens, typeSizeParse, _textTail, _type;
  getBytesAndSplit = function (bytes) {
    var bytesAndTail, integerBytes, size, sizeBytes, sizeLen, tail;
    sizeLen = 4;
    if(bytes.length < sizeLen + 1) {
      return false;
    }
    sizeBytes = bytes.slice(0, sizeLen);
    bytesAndTail = bytes.slice(sizeLen);
    size = ((sizeBytes.charCodeAt(0) << (8 * 3)) + (sizeBytes.charCodeAt(1) << (8 * 2))) + (sizeBytes.charCodeAt(2) << (8 * 1)) + (sizeBytes.charCodeAt(3) << (8 * 0));
    if(bytesAndTail.length < size) {
      return false;
    }
    integerBytes = bytesAndTail.slice(0, size);
    tail = bytesAndTail.slice(size);
    return [integerBytes, tail];
  };
  checkIntegers = function (num, bytes) {
    var result, _i, _int, _intNum;
    for(_intNum = _i = 0; 0 <= num ? _i < num : _i > num; _intNum = 0 <= num ? ++_i : --_i) {
      result = getBytesAndSplit(bytes);
      if(result === false) {
        return false;
      }
      _int = result[0]; bytes = result[1];
    }
    return bytes.length === 0;
  };
  keyTokens = rawKey.trim().split(" ");
  if(keyTokens.length < 2 || keyTokens.length > 3) {
    return false;
  }
  humanType = keyTokens[0]; keyBase64 = keyTokens[1]; _textTail = keyTokens[2];
  if(humanType !== "ssh-rsa" && humanType !== "ssh-dss") {
    return false;
  }
  if(_textTail && _textTail.includes('\n')) return false;
  try {
    keyBytes = window.atob(keyBase64);
  } catch(_error) {
    error = _error;
    return false;
  }
  typeSizeParse = getBytesAndSplit(keyBytes);
  if(!typeSizeParse) {
    return false;
  }
  _type = typeSizeParse[0]; keyBody = typeSizeParse[1];
  switch(humanType) {
    case "ssh-rsa":
      return checkIntegers(2, keyBody);
    case "ssh-dss":
      return checkIntegers(4, keyBody);
    default:
      return false;
  }

};

export function toParams(query) {
  const q = query.replace(/^\??\//, '');

  return q.split('&').reduce((values, param) => {
    const [key, value] = param.split('=');

    values[key] = value;

    return values;
  }, {});
}

export function toQuery(params, delimiter = '&') {
  const keys = Object.keys(params);

  return keys.reduce((str, key, index) => {
    let query = `${ str }${ key }=${ params[key] }`;

    if(index < (keys.length - 1)) {
      query += delimiter;
    }

    return query;
  }, '');

}

export function parseRedirect(url) {
  let redirect = {
    pathname: null,
    search: null
  };
  let pathQuerySplit = String(url).split('?', 2);
  redirect.pathname = pathQuerySplit[0];
  if(typeof pathQuerySplit[1] === 'string') redirect.search = pathQuerySplit[1];
  return redirect;
}

export const locationCount = "26";

